export default __webpack_public_path__ + "stumbler-screens@2x.7d203363.png";